// The company's time zone. "Today" is the calendar day here, for every date default, every
// min/max and every today-based check, whatever zone the browser is in. It MUST match the
// server's ATTENDANCE_TIMEZONE (server/constants/attendance.js), which defines companyToday()
// there; if the two differ, the client offers a day the server refuses.
export const COMPANY_TIME_ZONE = 'Asia/Karachi';

export const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const EMPLOYEE_STATUSES = [
  { value: '', label: 'All Status' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
  { value: 'terminated', label: 'Terminated' },
];

export const SALARY_STATUSES = [
  { value: '', label: 'All Status' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

// Exactly what an appraisal can be stored with: the appraisals.status CHECK in
// server/database/init.js and migrate.js. A value outside it can only ever filter to nothing.
export const APPRAISAL_STATUSES = [
  { value: '', label: 'All Status' },
  { value: 'pending', label: 'Pending' },
  { value: 'completed', label: 'Completed' },
  { value: 'overdue', label: 'Overdue' },
];

export const ONBOARDING_STATUSES = [
  { value: '', label: 'All Statuses' },
  { value: 'pending_review', label: 'Pending Review' },
  { value: 'in_review', label: 'In Review' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
];

// The fixed document categories, the server's DOCUMENT_CATEGORIES
// (server/constants/documents.js). A document filed before the list existed may carry
// another type; it stays readable but no new document can use one.
export const DOCUMENT_CATEGORIES = [
  'NIC',
  'Picture',
  'Educational Certificates',
  'Experience Certificate',
  'Resume/CV',
  'Signed Employment Contract',
  'Signed BYOD Agreement',
];

// What each category accepts, as the file picker's `accept` and the hint under it. The
// server judges the file's bytes and is the authority (server/constants/documents.js).
export const DOCUMENT_IMAGE_ACCEPT = '.jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp';
export const DOCUMENT_FILE_ACCEPT = `.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,${DOCUMENT_IMAGE_ACCEPT}`;
export const documentAcceptFor = (category) => (category === 'Picture' ? DOCUMENT_IMAGE_ACCEPT : DOCUMENT_FILE_ACCEPT);
export const documentKindsTextFor = (category) => (category === 'Picture' ? 'JPG, PNG or WebP' : 'PDF, Word, JPG, PNG or WebP');
export const MAX_DOCUMENT_BYTES = 10 * 1024 * 1024;

// The employment types, the server's EMPLOYMENT_TYPES (server/constants/employment.js).
export const EMPLOYMENT_TYPES = ['Full-time', 'Part-time', 'Contract', 'Intern', 'Trainee'];


export const LEAVE_STATUSES = [
  { value: '', label: 'All Status' },
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'cancelled', label: 'Cancelled' },
];

// Example: departments can be fetched from API, but you can add static fallback here
export const DEPARTMENTS = [
  { value: '', label: 'All Departments' },
  { value: 'IT', label: 'IT' },
  { value: 'HR', label: 'HR' },
  { value: 'Finance', label: 'Finance' },
  { value: 'Admin', label: 'Admin' },
  { value: 'Sales', label: 'Sales' },
  { value: 'Marketing', label: 'Marketing' },
]; 